import axios from "axios";
import Actions from "../Types";
import Instance from "../../utils/api";
import Instance2 from "../../utils/apiCert";
import responseHandler from "../../utils/responseHandler";
import Storage from "../../utils/storage";
import { setCurrentUser } from "./LoginActions";
import { clearPosState } from "./PosActions";

// Get Uploaded Docs
export const getDocsStart = () => ({
  type: Actions.GET_DOCS_LIST_START,
});

export const getDocsSuccess = (payload) => ({
  type: Actions.GET_DOCS_LIST_SUCCESS,
  payload,
});

export const getDocsFailure = (payload) => ({
  type: Actions.GET_DOCS_LIST_FAILURE,
  payload,
});

// Get Required Docs
export const getRequiredDocsStart = () => ({
  type: Actions.GET_REQUIRED_DOCS_LIST_START,
});

export const getRequiredDocsSuccess = (payload) => ({
  type: Actions.GET_REQUIRED_DOCS_LIST_SUCCESS,
  payload,
});

export const getRequiredDocsFailure = (payload) => ({
  type: Actions.GET_REQUIRED_DOCS_LIST_FAILURE,
  payload,
});

// Get User Status
export const getUserStatusStart = () => ({
  type: Actions.GET_USER_STATUS_START,
});

export const getUserStatusSuccess = (payload) => ({
  type: Actions.GET_USER_STATUS_SUCCESS,
  payload,
});

export const getUserStatusFailure = (payload) => ({
  type: Actions.GET_USER_STATUS_FAILURE,
  payload,
});

export const clearDocsState = () => ({
  type: Actions.CLEAR_DOCS_STATE,
});

// Get download SDK
export const downloadSDKStart = () => ({
  type: Actions.DOWNLOAD_SDK_STARTS,
});

export const downloadSDKSuccess = () => ({
  type: Actions.DOWNLOAD_SDK_SUCCESS,
});

export const downloadSDKFailure = (error) => ({
  type: Actions.DOWNLOAD_SDK_FAILURE,
  payload: error,
});
export const getKongAccessTokenStart = () => ({
  type: Actions.GET_KONG_ACCESS_TOKEN_START,
});
export const getKongAccessTokenSuccess = (payload) => ({
  type: Actions.GET_KONG_ACCESS_TOKEN_SUCCESS,
  payload,
});
export const getKongAccessTokenFailure = (payload) => ({
  type: Actions.GET_KONG_ACCESS_TOKEN_FAILURE,
  payload,
});

export const fetchCentralPayAccountStart = () => ({
  type: Actions.FETCH_CENTRALPAY_ACCOUNT_START,
});
export const fetchCentralPayAccountSuccess = (payload) => ({
  type: Actions.FETCH_CENTRALPAY_ACCOUNT_SUCCESS,
  payload,
});
export const fetchCentralPayAccountFailure = (payload) => ({
  type: Actions.FETCH_CENTRALPAY_ACCOUNT_FAILURE,
  payload,
});

export const makePaymentWithBankStart = () => ({
  type: Actions.MAKE_PAYMENT_WITH_BANK_START,
});
export const makePaymentWithBankSuccess = (payload) => ({
  type: Actions.MAKE_PAYMENT_WITH_BANK_SUCCESS,
  payload,
});
export const makePaymentWithBankFailure = (payload) => ({
  type: Actions.MAKE_PAYMENT_WITH_BANK_FAILURE,
  payload,
});

export const getBankNameAndCodeStart = () => ({
  type: Actions.GET_BANK_NAME_AND_CODE_START,
});
export const getBankNameAndCodeSuccess = (payload) => ({
  type: Actions.GET_BANK_NAME_AND_CODE_SUCCESS,
  payload,
});
export const getBankNameAndCodeFailure = (payload) => ({
  type: Actions.GET_BANK_NAME_AND_CODE_FAILURE,
  payload,
});

export const getVerifyBankTransferStart = () => ({
  type: Actions.GET_VERIFY_BANK_TRANSFER_START,
});
export const getVerifyBankTransferSuccess = (payload) => ({
  type: Actions.GET_VERIFY_BANK_TRANSFER_SUCCESS,
  payload,
});
export const getVerifyBankTransferFailure = (payload) => ({
  type: Actions.GET_VERIFY_BANK_TRANSFER_FAILURE,
  payload,
});


export const getCertificationAmountStart = () => ({
  type: Actions.GET_CERTIFICATION_AMOUNT_START,
});
export const getCertificationAmountSuccess = (payload) => ({
  type: Actions.GET_CERTIFICATION_AMOUNT_SUCCESS,
  payload,
});
export const getCertificationAmountFailure = (payload) => ({
  type: Actions.GET_CERTIFICATION_AMOUNT_FAILURE,
  payload,
});


export const getCertificationAmountByAppIdStart = () => ({
  type: Actions.GET_CERTIFICATION_AMOUNT_BY_APPID_START,
});
export const getCertificationAmountByAppIdSuccess = (payload) => ({
  type: Actions.GET_CERTIFICATION_AMOUNT_BY_APPID_SUCCESS,
  payload,
});
export const getCertificationAmountByAppIdFailure = (payload) => ({
  type: Actions.GET_CERTIFICATION_AMOUNT_BY_APPID_FAILURE,
  payload,
});

export const getApplicationByIdStart = ()=>({
  type: Actions.GET_APPLICATION_BY_ID_START
})
export const getApplicationByIdSuccess = (payload)=>({
  type: Actions.GET_APPLICATION_BY_ID_SUCCESS,
  payload
})

export const getApplicationByIdFailure = (payload)=>({
  type: Actions.GET_APPLICATION_BY_ID_FAILURE,
  payload
})

export const updatePosDetailsStart = ()=>({
  type: Actions.UPDATE_POS_DETAILS_START
})
export const updatePosDetailsSuccess = (payload)=>({
  type: Actions.UPDATE_POS_DETAILS_SUCCESS,
  payload
})
export const updatePosDetailsFailure = (payload)=>({
  type: Actions.UPDATE_POS_DETAILS_FAILURE,
  payload
})
export const getDocs = (type) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getDocsStart());
  API.get(`application/document?type=${type}`).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getDocsSuccess(data.data));
    } else {
      dispatch(getDocsFailure(data));
    }
  });
};

export const getRequiredDocs = (type) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getRequiredDocsStart());
  API.get(`document?type=${type}`).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getRequiredDocsSuccess(data.data));
    } else {
      dispatch(getRequiredDocsFailure(data));
    }
  });
};

export const getUserStatus = () => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getUserStatusStart());
  dispatch(setCurrentUser());
  dispatch(clearPosState());

  API.get("application/company/").then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getUserStatusSuccess(data.data));
    } else {
      dispatch(getUserStatusFailure(data));
    }
  });
};



export const downloadSDK = () => async (dispatch) => {
  dispatch(downloadSDKStart());

  const token = Storage.get("user-access-token");
  const apiKey = process.env.REACT_APP_API_KEY;

  try {
    const response = await axios.get(`${apiKey}/download-sdk`, {
      responseType: "arraybuffer",
      headers: {
        Authorization: token,
        Accept: "application/octet-stream",
      },
    });

    const contentType = response.headers["content-type"];
    const blob = new Blob([response.data], { type: contentType });
    const fileExtension =
      contentType === "application/octet-stream" ? "aar" : "bin";

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `nibss-pos-tracker.${fileExtension}`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    dispatch(downloadSDKSuccess());
  } catch (error) {
    console.error("Download failed:", error);
    dispatch(downloadSDKFailure(error));
  }
};



export const handleMicrosoftAccessToken = (productId) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));

  dispatch(getKongAccessTokenStart());
  API.get(`transaction/microsoft/token/${productId}`).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
    
      dispatch(getKongAccessTokenSuccess(data.data));
      Storage.set("kong-access-token", data.data.accessToken);
    } else {
      dispatch(getKongAccessTokenFailure(data));
    }
  });
};

export const fetchCentralPayAccountNumber =
  (token, payload) => async (dispatch) => {
    try {
      const API = Instance2.customAxiosInstance(
        Storage.get("user-access-token")
      );
      dispatch(fetchCentralPayAccountStart());
      const encodedToken = encodeURIComponent(token);
  
      const data = {
        payload,
        token: encodedToken,
      };

      API.post(`transaction/cpay/payment/bank-transfer`, data).then(
        (response) => {
          const { data, ok } = response;
          responseHandler(response);
          if (ok) {
     
            dispatch(fetchCentralPayAccountSuccess(data.data));
          } else {
            dispatch(fetchCentralPayAccountFailure(data));
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

export const makePaymentWithBankTransfer =
  (token, payload) => async (dispatch) => {
    try {
      const API = Instance2.customAxiosInstance(
        Storage.get("user-access-token")
      );
      dispatch(makePaymentWithBankStart());
      const encodedToken = encodeURIComponent(token);
     
      const data = {
        payload,
        token: encodedToken,
      };

      API.post(`transaction/cpay/payment/make-payment`, data, {headers: {Version: "v1"}}).then(
        (response) => {
          const { data, ok } = response;
          responseHandler(response);
          if (ok) {
            dispatch(makePaymentWithBankSuccess(data.data));
          } else {
            dispatch(makePaymentWithBankFailure(data));
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

export const handleGetBanksNameAndCode = () => async (dispatch) => {
  try {
    const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
    dispatch(getBankNameAndCodeStart());
    API.get(`transaction/cpay/payment/get-banks`).then((response) => {
      const { data } = response;
      responseHandler(response);
      if (data) {
        dispatch(getBankNameAndCodeSuccess(data.banks));
      } else {
        dispatch(getBankNameAndCodeFailure(data));
      }
    });
  } catch (e) {
    console.error(e);
  }
};



export const verifyPaymentWithBankTransfer =
  (_, transactionId, cpayTransId) => async (dispatch) => {
    const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
    const _token = Storage.get("kong-access-token");

    dispatch(getVerifyBankTransferStart());

    const encodedToken = encodeURIComponent(_token);
    const payload = { encodedToken, transactionId, cpayTransId };

    let response;

    try {
      response = await API.post(
        `transaction/cpay/payment/verify-bank-transfer`,
        payload,
        {
          responseType: "text",
          headers: {
            "Content-Type": "application/json",
            Accept: "text/html",
          },
        }
      );

      if (response.status === 200) {
        document.open();
        document.write(response.data.html);
        document.close();

        dispatch(getVerifyBankTransferSuccess());
        Storage.remove("kong-access-token");
     
       
      } else {
        document.open();
        document.write(response.data.html);
        document.close();
        dispatch(getVerifyBankTransferFailure(response.data));
        Storage.remove("kong-access-token");
      
        
      }
    } catch (error) {
      document.open();
      document.write(response.data.html);
      document.close();
      console.error("Error verifying bank transfer:", error);
      dispatch(getVerifyBankTransferFailure(error));
      Storage.remove("kong-access-token");
   
    }
  };

  export const getApplicationById = (appId, type) => async (dispatch) => {

    try {
      const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
      dispatch(getApplicationByIdStart());
      const response = await API.get(`application/transaction/applicationId/${type}/${appId}`);
      const { ok, data } = response;
 
      
      responseHandler(response);
      if (ok) {
        dispatch(getApplicationByIdSuccess(data));

      } else {
        dispatch(getApplicationByIdFailure(data));
     
      }
    } catch (error) {
      dispatch(getApplicationByIdFailure(error.message));
    }
    };

    export const getCertificationAmount = (type, appId) => async (dispatch) => {
  
  
      try {
        const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
        dispatch(getCertificationAmountStart());
        const response = await API.get(`transaction/certification/amount/${type}/${appId}`);
        const { ok, data } = response;
        
        responseHandler(response);
        if (ok) {
          dispatch(getCertificationAmountSuccess(data.data[0]));
    
        } else {
          dispatch(getCertificationAmountFailure(data.data));
        }
      } catch (error) {
        dispatch(getCertificationAmountFailure(error.message));
      }
    };
    
    export const getCertificationAmountByAppId = (appId) => async (dispatch) => {
    
    try {
      const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
      dispatch(getCertificationAmountByAppIdStart());
      Storage.remove("merchant_class");
      const response = await API.get(`transaction/certification/amount-by-app-id/${appId}`);
      const { ok, data } = response;
      
      responseHandler(response);
      if (ok) {
        Storage.set("certification_amount_id", data?.data[0]?.certification_amount_id)
        Storage.set("merchant_class", data?.data[0]?.merchant_class)
        dispatch(getCertificationAmountByAppIdSuccess(data.data[0]));
     
      } else {
        dispatch(getCertificationAmountByAppIdFailure(data.data));
       
      }
    } catch (error) {
      dispatch(getCertificationAmountByAppIdFailure(error.message));
    }
    };
    export const updateCertificationDetails = (payload, appId) => async (dispatch) => {

      try {
        const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
        dispatch(updatePosDetailsStart());
        const response = await API.put(`transaction/certification/edit/name-and-version/`, {payload, appId});
        const { ok, data } = response;
        
        responseHandler(response);
        if (ok) {
          dispatch(updatePosDetailsSuccess(data.data));
 
        } else {
          dispatch(updatePosDetailsFailure(data.data));
        }
      } catch (error) {
        dispatch(updatePosDetailsFailure(error.message));
      }
      };
  
  